"use client";

import type { AccountStatusResponse } from "@/helpers/api/WRA/registration/getAccountStatus";
import { getAccountStatus } from "@/libs/builder/builderApi";
import { FC, PropsWithChildren, useEffect } from "react";

export type GetAccountStatusRequest = {
  id: string;
};

type AccountStatusMessageProps = {
  onFinish: (status: AccountStatusResponse) => void;
};
export const AccountStatusMessage: FC<
  PropsWithChildren<AccountStatusMessageProps>
> = ({ children, onFinish }) => {
  useEffect(() => {
    let requestCount = 0;
    const fetchAccountStatus = async () => {
      try {
        const status = await getAccountStatus();
        if (
          requestCount === 3 ||
          (status && "status" in status && status.status === 0)
        ) {
          onFinish(status);
        }
      } catch {
        // Do nothing
      }
    };

    const interval = setInterval(() => {
      requestCount++;
      fetchAccountStatus();
      if (requestCount === 3) {
        clearInterval(interval);
      }
    }, 10000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};
